import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import Styled from './styles';
import InlineFeedbackOverlay, { InlineFeedbackOverlayProps } from './InlineFeedbackOverlay';

export interface InlineFeedbackMessagesContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** Renders an overlay behind the Inline Feedback Messages. The overlay will expand to the nearest relatively positioned parent container, alternatively, you can use overlayProps to pass in a `target` prop, the overlay will expand within that target container. */
  overlay?: boolean;
  /** Pass props into the overlay. Specifying the target prop will allow the overlay to fill that target container. */
  overlayProps?: Partial<InlineFeedbackOverlayProps>;
  /** Override the theme. Please refer to the "Readme" tab to learn more on theme structure. */
  theme?: any;
}

/** InlineFeedbackMessagesContainer, place multiple feedback messages here.
 * All additional props will be forwarded to the root element.
*/

const InlineFeedbackMessagesContainer = React.forwardRef<HTMLElement, InlineFeedbackMessagesContainerProps>((props: InlineFeedbackMessagesContainerProps, ref) =>
  getContext(({ RTL, theme: globalTheme }) => {
    const resolvedTheme = _merge({}, globalTheme.INLINE_FEEDBACK_MESSAGES, props.theme);
    const InlineFeedbackMessagesInner = (
      <Styled.InlineFeedbackMessagesContainer ref={ref} $overlay={props.overlay} $rtl={RTL} {...props} />
    );
    if (props.overlay) {
      return <InlineFeedbackOverlay theme={resolvedTheme} {...props.overlayProps}>{InlineFeedbackMessagesInner}</InlineFeedbackOverlay>;
    }
    return InlineFeedbackMessagesInner;
  }));

InlineFeedbackMessagesContainer.defaultProps = {
  overlay: false,
  overlayProps: undefined,
  theme: {}
};
InlineFeedbackMessagesContainer.displayName = 'InlineFeedbackMessagesContainer';

/* Exports */
export { InlineFeedbackMessagesContainer as default };
